// extracted by mini-css-extract-plugin
export default {"container":"JCOUb","truncateName":"lU+Rs","detailsRoleIcons":"tRQcB"};